// extracted by mini-css-extract-plugin
export default {"chooser":"CustomerChooser_chooser__5S+mG","chooserWrapper":"CustomerChooser_chooserWrapper__ZpE+a","chooserWrapperInner":"CustomerChooser_chooserWrapperInner__udF0C"};